var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4594 8.94219C14.9101 8.39321 15.1957 7.72751 15.2828 7.02256C15.37 6.3176 15.2551 5.6024 14.9516 4.96019C14.6481 4.31797 14.1684 3.77517 13.5684 3.39496C12.9685 3.01474 12.2728 2.81275 11.5625 2.8125H6.25C6.00136 2.8125 5.7629 2.91127 5.58709 3.08709C5.41127 3.2629 5.3125 3.50136 5.3125 3.75V15.625C5.3125 15.8736 5.41127 16.1121 5.58709 16.2879C5.7629 16.4637 6.00136 16.5625 6.25 16.5625H12.5C13.401 16.5621 14.2764 16.2622 14.9883 15.7099C15.7003 15.1576 16.2084 14.3843 16.4328 13.5117C16.6572 12.639 16.5851 11.7165 16.2278 10.8893C15.8706 10.0621 15.2485 9.37715 14.4594 8.94219ZM7.1875 4.6875H11.5625C12.0598 4.6875 12.5367 4.88504 12.8883 5.23667C13.24 5.58831 13.4375 6.06522 13.4375 6.5625C13.4375 7.05978 13.24 7.53669 12.8883 7.88833C12.5367 8.23996 12.0598 8.4375 11.5625 8.4375H7.1875V4.6875ZM12.5 14.6875H7.1875V10.3125H12.5C13.0802 10.3125 13.6366 10.543 14.0468 10.9532C14.457 11.3634 14.6875 11.9198 14.6875 12.5C14.6875 13.0802 14.457 13.6366 14.0468 14.0468C13.6366 14.457 13.0802 14.6875 12.5 14.6875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldIcon);
export default __webpack_public_path__ + "static/media/BoldIcon.516adae59fc19d55db002b9a4a67bcda.svg";
export { ForwardRef as ReactComponent };